import React from 'react';
import PropTypes from 'prop-types';
import { getElementTooltip } from '../../helpers/uiHelpers';
import { productionChartTabToolTips } from '../../constants/agentProductionConstants';

export const SummaryCard = ({ id, value, children }) => (
    <div className="helix-card ">
        <div className="helix-card__body">
            {children ?? <>
                <div className="helix-body my-3">
                    {getElementTooltip(productionChartTabToolTips[id], true)}
                </div>
                <p className="my-3 text-nowrap helix-display-x-small">{value}</p>
            </>}
        </div>
    </div>
);

SummaryCard.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    children: PropTypes.object,
};
